import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Services from "@/pages/Services";
import Categories from "@/pages/Categories";
import HowItWorks from "@/pages/HowItWorks";
import SupplierVerification from "@/pages/SupplierVerification";
import Quote from "@/pages/Quote";
import Contact from "@/pages/Contact";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminMessages from "@/pages/AdminMessages";
import AdminInsights from "@/pages/AdminInsights";
import Insights from "@/pages/Insights";
import BecomeSupplier from "@/pages/BecomeSupplier";

function Public({ children }) {
  return <Layout>{children}</Layout>;
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          {/* Admin (no public layout) */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/admin/messages" element={<AdminMessages />} />
          <Route path="/admin/insights" element={<AdminInsights />} />

          {/* Public site */}
          <Route path="/" element={<Public><Home /></Public>} />
          <Route path="/about" element={<Public><About /></Public>} />
          <Route path="/services" element={<Public><Services /></Public>} />
          <Route path="/categories" element={<Public><Categories /></Public>} />
          <Route path="/how-it-works" element={<Public><HowItWorks /></Public>} />
          <Route path="/supplier-verification" element={<Public><SupplierVerification /></Public>} />
          <Route path="/quote" element={<Public><Quote /></Public>} />
          <Route path="/become-a-supplier" element={<Public><BecomeSupplier /></Public>} />
          <Route path="/insights" element={<Public><Insights /></Public>} />
          <Route path="/contact" element={<Public><Contact /></Public>} />
          <Route path="/privacy" element={<Public><Privacy /></Public>} />
          <Route path="/terms" element={<Public><Terms /></Public>} />
          <Route path="*" element={<Public><Home /></Public>} />
        </Routes>
        <Toaster theme="dark" position="top-right" />
      </BrowserRouter>
    </div>
  );
}
